
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"b","maskUnits":"userSpaceOnUse","x":"0","y":"1","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 1h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#b)"}},[_c('path',{attrs:{"d":"M6.667 3a.645.645 0 01-.475-.192A.645.645 0 016 2.333c0-.189.064-.347.192-.475a.645.645 0 01.475-.192h2.666c.19 0 .348.064.475.192a.645.645 0 01.192.475.645.645 0 01-.192.475.645.645 0 01-.475.192H6.667zM8 10.333a.645.645 0 00.475-.191.645.645 0 00.192-.476V7a.645.645 0 00-.192-.475A.645.645 0 008 6.333a.645.645 0 00-.475.192.645.645 0 00-.192.475v2.666c0 .19.064.348.192.476a.645.645 0 00.475.191zm0 5.333a5.763 5.763 0 01-2.325-.475A6.128 6.128 0 013.767 13.9a6.128 6.128 0 01-1.292-1.909A5.764 5.764 0 012 9.666c0-.822.158-1.597.475-2.325a6.129 6.129 0 011.292-1.908 6.129 6.129 0 011.908-1.292A5.764 5.764 0 018 3.667c.689 0 1.35.11 1.983.333a6.482 6.482 0 011.784.966l.466-.466a.632.632 0 01.467-.184c.189 0 .344.062.467.184a.632.632 0 01.183.466.632.632 0 01-.183.467L12.7 5.9c.422.555.744 1.15.967 1.783.222.633.333 1.295.333 1.983 0 .823-.158 1.598-.475 2.325a6.127 6.127 0 01-1.292 1.909 6.127 6.127 0 01-1.908 1.291A5.763 5.763 0 018 15.666z","fill":"#4062D7"}})])])])
          )
        }
      }
    